/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionRegion } from './subscriptionRegion';
import { DataCentersEnum } from './dataCentersEnum';


export interface DataCenter { 
    data_center?: DataCentersEnum;
    subscription_region?: SubscriptionRegion;
}
export namespace DataCenter {
}


